import { clientWithCredentials } from "../_helpers";
import { licencesConstants, alertConstants } from "../_constants";

export const licencesAction = {
    loadLicences
};

function loadLicences() {
    return function(dispatch:any) {
        dispatch({
            type: licencesConstants.LICENCES_LOADING
        });
        clientWithCredentials(dispatch).get("api/licencetype?showOutdated=true")
            .then((data) => {
                dispatch({
                    type: licencesConstants.LICENCES_LOADED,
                    data: data.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: licencesConstants.LICENCES_ERROR
                });
                dispatch({
                    type: alertConstants.ALERT_SHOW,
                    notification: {
                        message: error.message,
                        level: "error"
                    }
                });
            })
    };
}